import React, { useEffect, useState } from "react";
import { Link } from "gatsby";
import Container from "./container";
import IntegrationCard from "./integration-card";
import { cn } from "../lib/helpers";
import Icon from "./icon";
import PortableText from "./portableText";
import ScrollContainer from 'react-indiana-drag-scroll';

import * as styles from "../styles/components/integrations-section.module.css";

const IntegrationsSection = (props) => {

  const {
    heading,
    _rawContent,
    link,
    integrations
  } = props;

  function shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      const temp = array[i];
      array[i] = array[j];
      array[j] = temp;
    }
    return array;
  }

  const [shuffled,setShuffled] = useState([]);
  useEffect(() => {
    setShuffled(shuffleArray(integrations));
  })

  return (
    <div className={styles.root}>
      <Container>
        {heading && <div className="content-xl"><h2 className={cn("h3", styles.heading)}>{heading}</h2></div>}
        {_rawContent && <div className="content-sm"><PortableText blocks={_rawContent} /></div>}
        {link && link.url && 
          <>
            {link.blank
              ? <a href={link.url} className="link" target="_blank" rel="noreferrer">{link.text}<Icon symbol="arrow-right" /></a>
              : <Link to={link.url} className="link">{link.text}<Icon symbol="arrow-right" /></Link>
            }
          </>
        }
      </Container>
      {(shuffled && shuffled.length) 
        ? <ScrollContainer className={styles.slider} vertical="false" hideScrollbars="false">
            <div className={styles.inner}>
              {shuffled.map(({ integration, _key }) => {
                return (
                  <div key={_key} className={styles.item} tabindex="0">
                    <IntegrationCard integration={integration} />
                  </div>
                );
              })}
            </div>
          </ScrollContainer>
        : null
      }
    </div>
  );
}

export default IntegrationsSection;
